import React, { useState, useEffect } from "react";
import "./ProductSpecificAgreement.modules.css"; // We'll create this CSS file next
import { EyeFill } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import * as Helpers from "../../../../global/Helpers";
import * as Constants from "../../../../constants/Constants";

const ProductSpecificAgreement = (props) => {
  const { t } = useTranslation();
  const companyName = localStorage
    .getItem(Constants.localStorageConstants.company_name)
    ?.toUpperCase();

  const [agreements, setAgreements] = useState({
    retail: false,
    trading: false,
    terms: false,
    fees: false,
    business: false,
    margin: false,
    international: false,
    subscription: false,
    sweep: false,
    redemption: false,
    ShowBalance: false,
  });

  const handleAgreementChange = (e) => {
    const { name, checked } = e.target;
    setAgreements((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const handleAcceptAll = () => {
    const allAccepted = Object.keys(agreements).reduce((acc, key) => {
      acc[key] = true;
      return acc;
    }, {});
    setAgreements(allAccepted);
  };

  // useEffect(() => {
  //     
  //     if (props.IsCallAPI){
  //         props.setIsCallAPI(false);
  //         props.handleNext();
  //     }

  // }, [props.IsCallAPI]);

  useEffect(() => {
    ;
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  const saveKycDataFun = () => {
    ;
    // if (!validateSubmit())
    //     return;

    var result = Helpers.getScreenIdByGroupAndName("Product Specific Agreement");

    var Items = [
      { ID: "286", Value: agreements.ShowBalance === false ? "N" : "Y" },
      { ID: "258", Value: "1" },
      { ID: "288", Value: result?.GROUP_ID || "" },
      { ID: "287", Value: result?.SCREEN_ID || "" },
    ];
    props.saveKycDataAPI(Items);
  };
  return (
    <div className="ProductSpecificAgreement-container">
      <div className="progress-bar">
        {/* Implement progress bar logic here */}
      </div>

      <h2>{t("product_specific_agreement")}</h2>
      <label>{t("kindly_review_and_accept")}</label>

      <div className="agreements-container">
        <div className="agreement-item">
          <label> {t("Agreements")}</label>
          <button className="accept-all" onClick={handleAcceptAll}>
            {t("accept_all")}
          </button>
        </div>

        <div className="agreement-item">
          <label>{t("account_opening_agreement_retail")}</label>
          <div className="EyeDiv">
            <EyeFill size={15} color={ companyName === "ADCB" ? "#BA1B19" : "#E37D00"} />
            <input
              type="checkbox"
              name="retail"
              checked={agreements.retail}
              onChange={handleAgreementChange}
            />
          </div>
        </div>

        {/* <div className="agreement-item">
                    <label>{ t("online_trading_agreement")}</label>
                    <div className='EyeDiv'>
                        <EyeFill size={15} color='#E37D00' />
                        <input type="checkbox" name="trading" checked={agreements.trading} onChange={handleAgreementChange} />
                    </div>
                </div> */}

        {/* <div className="agreement-item">
                    <label>{ t("general_trading_terms_and_conditions")}</label>
                    <div className='EyeDiv'>
                        <EyeFill size={15} color='#E37D00' />
                        <input type="checkbox" name="terms" checked={agreements.terms} onChange={handleAgreementChange} />
                    </div>
                </div> */}

        {/* <div className="agreement-item">
                    <label> { t("service_fees")}</label>
                    <div className='EyeDiv'>
                        <EyeFill size={15} color='#E37D00' />
                        <input type="checkbox" name="fees" checked={agreements.fees} onChange={handleAgreementChange} />
                    </div>
                </div> */}
        {/* <div className="agreement-item">
                    <label>{ t("general_terms_of_business")}</label>
                    <div className='EyeDiv'>
                        <EyeFill size={15} color='#E37D00' />
                        <input type="checkbox" name="business" checked={agreements.business} onChange={handleAgreementChange} />
                    </div>
                </div> */}
        <div className="agreement-item">
          <label>{t("product_margin_trading_agreement")}</label>
          <div className="EyeDiv">
            <EyeFill size={15} color={ companyName === "ADCB" ? "#BA1B19" : "#E37D00"} />
            <input
              type="checkbox"
              name="margin"
              checked={agreements.margin}
              onChange={handleAgreementChange}
            />
          </div>
        </div>
        <div className="agreement-item">
          <label>{t("product_international_trading")}</label>
          <div className="EyeDiv">
            <EyeFill size={15} color={ companyName === "ADCB" ? "#BA1B19" : "#E37D00"} />
            <input
              type="checkbox"
              name="international"
              checked={agreements.international}
              onChange={handleAgreementChange}
            />
          </div>
        </div>
        <div className="agreement-item">
          <label>{t("ShowBalance")}</label>
          <div className="EyeDiv">
            <EyeFill size={15} color={ companyName === "ADCB" ? "#BA1B19" : "#E37D00"} />
            <input
              type="checkbox"
              name="ShowBalance"
              checked={agreements.ShowBalance}
              onChange={handleAgreementChange}
            />
          </div>
        </div>
        {/* <div className="agreement-item">
                    <label>{ t("product_subscription_form_asset_management")}  </label>
                    <div className='EyeDiv'>
                        <EyeFill size={15} color='#E37D00' />
                        <input type="checkbox" name="subscription" checked={agreements.subscription} onChange={handleAgreementChange} />

                    </div>
                </div>
                <div className="agreement-item">
                    <label>{ t("product_sweep_authorization_form_asset_management")} </label>
                    <div className='EyeDiv'>
                        <EyeFill size={15} color='#E37D00' />
                        <input type="checkbox" name="sweep" checked={agreements.sweep} onChange={handleAgreementChange} />

                    </div>
                </div>
                <div className="agreement-item">
                    <label>{ t("product_redemption_form_asset_management")}  </label>
                    <div className='EyeDiv'>
                        <EyeFill size={15} color='#E37D00' />
                        <input type="checkbox" name="redemption" checked={agreements.redemption} onChange={handleAgreementChange} />

                    </div>
                </div> */}

        {/* Continue for all the agreements listed in your UI */}
      </div>
    </div>
  );
};

export default ProductSpecificAgreement;
